import { z } from 'zod';
import { SortQuerySchema } from '../common';
import { INVOICE_TYPE } from '../cobros';
import { CORTE_MORA_EXPORT_FORMAT } from './types';

const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;

/** Filter schema shared by list, stats, and export requests. */
export const CorteMoraFiltersSchema = z.object({
  search: z.string().trim().max(120).optional(),
  idCliente: z.coerce.number().int().positive().optional(),
  tipoFactura: z.enum([INVOICE_TYPE.PERIODICA, INVOICE_TYPE.EXTRAORDINARIA]).optional(),
  fechaDesde: z.string().regex(isoDateRegex, 'fechaDesde must be YYYY-MM-DD').optional(),
  fechaHasta: z.string().regex(isoDateRegex, 'fechaHasta must be YYYY-MM-DD').optional(),
});

export const QueryCorteMoraSchema = CorteMoraFiltersSchema.extend({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
}).merge(SortQuerySchema);

export type QueryCorteMoraInput = z.input<typeof QueryCorteMoraSchema>;
export type QueryCorteMora = z.infer<typeof QueryCorteMoraSchema>;

export const CorteMoraExportQuerySchema = CorteMoraFiltersSchema.extend({
  format: z.enum([CORTE_MORA_EXPORT_FORMAT.PDF, CORTE_MORA_EXPORT_FORMAT.XLSX]),
});

export type CorteMoraExportQuery = z.infer<typeof CorteMoraExportQuerySchema>;
